export interface ImpactTier {
  readonly rampDown: number;
  readonly hold: number;
  readonly scale: number;
  readonly rampUp: number;
  readonly trauma: number;
  readonly flashHold: number;
  readonly flashOut: number;
  readonly punch: number;
}

export interface FeelTable {
  readonly light: ImpactTier;
  readonly heavy: ImpactTier;
  readonly kill: ImpactTier;
  readonly heavyFraction: number;
  readonly traumaExponent: number;
  readonly traumaDecay: number;
  readonly shakeHz: number;
  readonly shakeAmplitude: number;
  readonly shakeRoll: number;
  readonly punchOmega: number;
  readonly punchZeta: number;
  readonly hitstopBudget: number;
  readonly hitstopRefractory: number;
}

export const FEEL: FeelTable = {
  light: {
    rampDown: 0.006,
    hold: 0.014,
    scale: 0.42,
    rampUp: 0.045,
    trauma: 0.15,
    flashHold: 0.035,
    flashOut: 0.04,
    punch: 0.18
  },
  heavy: {
    rampDown: 0.008,
    hold: 0.028,
    scale: 0.22,
    rampUp: 0.07,
    trauma: 0.4,
    flashHold: 0.05,
    flashOut: 0.06,
    punch: 0.42
  },
  kill: {
    rampDown: 0.01,
    hold: 0.042,
    scale: 0.14,
    rampUp: 0.095,
    trauma: 0.35,
    flashHold: 0.06,
    flashOut: 0.2,
    punch: 0.52
  },
  heavyFraction: 0.34,
  traumaExponent: 3,
  traumaDecay: 2.1,
  shakeHz: 21,
  shakeAmplitude: 0.42,
  shakeRoll: 0.014,
  punchOmega: 22,
  punchZeta: 0.55,
  hitstopBudget: 0.15,
  hitstopRefractory: 0.3
};
